export abstract class HistoryState {}
